import { BRAND } from '../data/siteContent';

const DEFAULT_DESC =
  'AI-powered GED preparation with an always-on tutor, practice exams, quizzes, and flexible study plans at Success Bridge Academy.';

export const SEO_ROUTES = {
  '/': {
    title: `${BRAND.name} | AI-Powered GED Preparation`,
    description: DEFAULT_DESC,
  },
  '/about': {
    title: `About ${BRAND.name} | GED Academy`,
    description: `Learn how ${BRAND.name} helps students earn a U.S. high school equivalency credential with AI tutoring and structured GED courses.`,
  },
  '/program': {
    title: `GED Program | ${BRAND.name}`,
    description:
      'Study all four GED subjects — Mathematical Reasoning, Science, Reasoning Through Language Arts, and Social Studies — with AI-guided lectures.',
  },
  '/how-it-works': {
    title: `How It Works | ${BRAND.name}`,
    description: 'See how enrollment, AI lectures, quizzes, and practice exams work at Success Bridge Academy.',
  },
  '/pricing': {
    title: `GED Study Plans & Pricing | ${BRAND.name}`,
    description: 'Compare GED study plans, duration, and what is included with AI tutoring and practice exams.',
  },
  '/success-stories': {
    title: `Success Stories | ${BRAND.name}`,
    description: 'Read how students prepared for the GED with Success Bridge Academy.',
  },
  '/faq': {
    title: `GED FAQ | ${BRAND.name}`,
    description: 'Answers about GED eligibility, study plans, AI tutoring, payments, and practice exams.',
  },
  '/blog': {
    title: `GED Study Guides & Blog | ${BRAND.name}`,
    description: 'Practical articles on GED prep, study rhythm, and AI practice exams.',
  },
  '/contact': {
    title: `Contact | ${BRAND.name}`,
    description: `Talk to ${BRAND.name} about GED enrollment, study plans, and payments.`,
  },
  '/services': {
    title: `Services | ${BRAND.name}`,
    description: 'GED course library, AI tutor, quizzes, practice exams, and student portal services.',
  },
  '/privacy-policy': {
    title: `Privacy Policy | ${BRAND.name}`,
    description: `Privacy policy for ${BRAND.name} students and website visitors.`,
  },
  '/refund-cancellation-policy': {
    title: `Refund & Cancellation Policy | ${BRAND.name}`,
    description: `Refund and cancellation terms for ${BRAND.name} study plans.`,
  },
  '/service-delivery-policy': {
    title: `Service Delivery Policy | ${BRAND.name}`,
    description: `How ${BRAND.name} delivers GED study access after enrollment and payment.`,
  },
  '/terms-and-conditions': {
    title: `Terms & Conditions | ${BRAND.name}`,
    description: `Terms of use for the ${BRAND.name} website and student portal.`,
  },
  '/login': {
    title: `Student Login | ${BRAND.name}`,
    description: 'Sign in to your Success Bridge Academy student portal.',
  },
  '/signup': {
    title: `Enroll | ${BRAND.name}`,
    description: 'Create your Success Bridge Academy account and start GED preparation.',
  },
};

export function seoForPath(pathname) {
  if (SEO_ROUTES[pathname]) return SEO_ROUTES[pathname];
  if (pathname.startsWith('/program/')) {
    return {
      title: `GED Subject | ${BRAND.name}`,
      description: 'GED subject overview, topics, and how Success Bridge Academy teaches with AI.',
    };
  }
  if (pathname.startsWith('/blog/')) {
    return {
      title: `GED Article | ${BRAND.name}`,
      description: 'GED preparation guidance from Success Bridge Academy.',
    };
  }
  return {
    title: `${BRAND.name} | Bridge the Gap to Your Future`,
    description: DEFAULT_DESC,
  };
}

export function absoluteUrl(path = '/') {
  const base = String(BRAND.websiteUrl || '').replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}
